import GearOutline from './GearOutline'

export default GearOutline
// eslint-disable-next-line import/export
export * from './GearOutline'
